import { z } from "zod";
import { calendarDateString } from "./calendar-date.js";
// Request/response schemas for content search endpoints.
// GET  /api/content/search
// POST /api/content/swap
// GET  /api/content/:uuid/explain
export const ContentItem = z.object({
    cmsUuid: z.string(),
    contentType: z.string(),
    title: z.string(),
    subtitle: z.string().nullable().optional(),
    allergens: z.array(z.string()),
    dietaryLabels: z.array(z.string()),
    metadata: z.record(z.string(), z.unknown()),
    distance: z.number(),
    /** Why this alternative fits, populated on swap responses when a reason was given. */
    planFit: z.string().nullable().optional(),
});
export const ContentSearchQuery = z.object({
    contextText: z.string().min(1).max(2000),
    contentType: z.string().optional(),
    locale: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(50).optional(),
});
export const ContentSearchResponse = z.object({
    items: z.array(ContentItem),
});
export const ContentSwapRequest = z.object({
    cmsUuid: z.string().min(1),
    locale: z.string().optional(),
    /** Free-text reason the user wants to swap (e.g. "don't like salmon", "too complex"). */
    reason: z.string().max(500).optional(),
});
export const SwapFeedbackRequest = z.object({
    cmsUuid: z.string().min(1),
    reason: z.string().min(1).max(500),
});
export const ContentSwapResponse = z.object({
    alternatives: z.array(ContentItem),
});
export const ContentExplainQuery = z.object({
    planDate: calendarDateString("planDate").optional(),
});
export const ContentExplainResponse = z.object({
    explanation: z.string(),
});
//# sourceMappingURL=content-search.js.map